import { render, staticRenderFns } from "./new-conversation-button.vue?vue&type=template&id=8700c066&"
import script from "./new-conversation-button.vue?vue&type=script&lang=ts&"
export * from "./new-conversation-button.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports